import { useCallback, useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { getDialPadVariantFromLocalStorage } from 'features/dial-pad/helpers';
import {
  clearAndCloseDialPad,
  clearSharedTextAndDialPadThunk,
  isDialPadOpenedSelector,
  selectDialedNumberOnNumberPad,
  setDialPadVariant,
} from 'features/dial-pad/store';

export const useDialPadOperations = () => {
  const dispatch = useAppDispatch();
  const dialedNumber = useAppSelector(selectDialedNumberOnNumberPad);
  const isDialPadOpened = useAppSelector(isDialPadOpenedSelector);

  const dialedNumberRef = useRef('');

  // Initialize dial pad variant from localStorage
  useEffect(() => {
    const dialPadVariantFromLocalStorage = getDialPadVariantFromLocalStorage();
    if (dialPadVariantFromLocalStorage) {
      dispatch(setDialPadVariant(dialPadVariantFromLocalStorage));
    }
  }, [dispatch]);

  // Keep ref synced with dialed number
  useEffect(() => {
    dialedNumberRef.current = dialedNumber;
  }, [dialedNumber]);

  const clearDialedNumbers = useCallback(() => {
    if (dialedNumberRef.current) {
      dispatch(clearSharedTextAndDialPadThunk(dialedNumberRef.current));
    }
  }, [dispatch]);

  const clearAllAndCloseDialPad = useCallback(() => {
    if (dialedNumberRef.current) {
      dispatch(clearSharedTextAndDialPadThunk(dialedNumberRef.current));
    }
    dispatch(clearAndCloseDialPad());
  }, [dispatch]);

  // Auto-clear and close when dial pad closes with content
  useEffect(() => {
    if (dialedNumberRef.current?.length > 0) {
      clearAllAndCloseDialPad();
    }
  }, [clearAllAndCloseDialPad, isDialPadOpened]);

  return {
    dialedNumber,
    clearDialedNumbers,
    clearAllAndCloseDialPad,
  };
};
